const StockTransfer = {

    // FIELDS
    "ware_house": "المستودع",
    "sale_type": "نوع البيع",
    "remark": "ملاحظة",
    "search": "بحث",
    "item": "العنصر",
    "rate": "السعر",
    "quantity": "الكمية",
    "unit": "الوحدة",
    "vat": "ضريبة القيمة المضافة (%)",
    "sub_total": "المجموع الفرعي",
    "total": "المجموع",

    // BUTTON
    "clear_item": "مسح العناصر التي أسعارها 0",

    // PAGE HEADER
    "stock_transfer": "تحويل المخزون",

    // SWEET ALERT
    "pricing": "التسعير",
    "pricing_message": "بعض العناصر لم يتم تحديث أسعارها، يرجى إزالة هذه العناصر",

    // ERROR
    "error_ware_house": "اختر المستودع",
    "error_sale_type": "اختر نوع البيع",
    "error_remark": "أدخل الملاحظات",
    "error_item": "اختر العنصر",
    "error_rate": "أدخل السعر",
    "error_quantity": "أدخل الكمية",
    "error_positive": "القيمة يجب أن تكون موجبة",
    "error_vat": "الضريبة مطلوبة",

    // TABLE HEADER
    "table_stock_id": "معرف المخزون",
    "table_ware_house": "المستودع",
    "table_sale_type": "نوع البيع",
    
}

export default StockTransfer;